export default class Address {
  city: string = '';
  area: string = '';
  zipCode: string = '';
  address: string = '';
  fullAddress: string = '';
  addressInput: string = ''; // 輸入的地址，受使用者影響

  get addressWithoutZipCode(): string {
    return `${this.city}${this.area}${this.address}`;
  }

  constructor(data: Partial<Address> = {}) {
    Object.assign(this, data);
  }

  clone(): Address {
    return new Address(this);
  }
}